import img1 from '../../assets/testimonials/VukosavaScekicJelisavac.jpg';
import img2 from '../../assets/testimonials/MilosPavlovic.jpg';
import img3 from '../../assets/testimonials/OliveraTesic.jpg';
import img4 from '../../assets/testimonials/MarinaGrahovac.jpg';
import img5 from '../../assets/testimonials/DraganStevanovic.jpg';


const testimonialsData = [
  {
    id: 1,
    name: "Vukosava Šćekić Jelisavac",
    subtitle: "RODITELJ",
    title: "„Empatija, podrška i zajedništvo u praksi“",
    text: `U Savremenoj školi moja deca imaju prostor da budu svoja, da razvijaju svoje talente i uče važne životne vrednosti poput empatije, podrške i zajedništva. Kao roditelj, posebno cenim što škola neguje različitost svakog deteta i gradi snažnu zajednicu kroz blisku saradnju sa roditeljima.`,
    image: img1,
  },
  {
    id: 2,
    name: "Miloš Pavlović",
    subtitle: "RODITELJ",
    title: "„Bezbedno i podsticajno okruženje za razvoj“",
    text: `U Savremenoj školi pronašli smo bezbedno i podsticajno okruženje u kome naše dete uči i razvija se uz posvećene i profesionalne nastavnike. Uz otvorenu komunikaciju i dodatne edukativne sadržaje, imamo potpuno poverenje da smo napravili pravi izbor za njegovo odrastanje i obrazovanje.`,
    image: img2,
  },
  {
    id: 3,
    name: "Olivera Tešić",
    subtitle: "RODITELJ",
    title: "„Mesto gde deca procvetaju“",
    text: `U Savremenoj školi moje dete je uz podršku i razumevanje nastavnika procvetalo, razvilo samopouzdanje i postalo spremno za dalje obrazovanje i život.`,
    image: img3,
  },
  {
    id: 4,
    name: "Marina Grahovac",
    subtitle: "RODITELJ",
    title: "„Sve što želim za svoju decu – emotivni, intelektualni i fizički razvoj“",
    text: `Ja sam od onih zadovoljnih roditelja. Ono što je meni važno jeste da primećujem na svojoj deci jedan emotivni, intelektualni i fizički razvoj. To je meni kao roditelju zaista dovoljno. Deca su prezadovoljna i mogu da razviju sve svoje talente, a samim tim mogu i da napreduju.`,
    image: img4,
  },
  {
    id: 5,
    name: "Dragan Stevanović",
    subtitle: "RODITELJ",
    title: "„Fokus na celokupan razvoj deteta“",
    text: `Mi smo prezadovoljni školom i od srca bismo je preporučili svim našim prijateljima. Posebno cenimo način na koji se naše dete obrazuje – sa pažnjom, razumevanjem i fokusom na njegov celokupan razvoj.`,
    image: img5,
  },
];

export default testimonialsData;